import {FC} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../helpers'

interface props {
  width?: string
  height?: string
  minWidht?: string
  minHeight?: string
}

const CardLoading: FC<props> = ({width, height}) => {
  const intl = useIntl()

  return (
    <>
      <div className='card-body d-flex align-items-center pt-1 pb-3'>
        <img
          width={width || '30px'}
          min-width='100px'
          height={height || '30%'}
          alt='Orbit'
          src={toAbsoluteUrl('/media/logos/globo.gif')}
        />
        <br />
        <span className='fs-7 fw-bold'>{intl.formatMessage({id: 'AUTH.PLEASEWAIT'})}</span>
      </div>
    </>
  )
}

export {CardLoading}
